import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { CookieRedirect } from 'components/utils/helpers';
import classnames from 'classnames';
// Images
import Logo from 'svg/logo';
import Arrow from 'svg/arrow-small';
import introBgVideo from 'static/video/intro_bg.mp4';
import introBgPoster from 'static/images/intro_bg.jpeg';
import logoLockup from 'static/images/logo-lockup.png';
import intro1 from 'static/images/intro_1.png';
import intro2 from 'static/images/intro_2.png';
import intro3 from 'static/images/intro_3.png';
import intro4 from 'static/images/intro_4.png';
import intro5 from 'static/images/intro_5.png';
import intro6 from 'static/images/intro_6.png';
import intro7 from 'static/images/intro_7.png';
import introExperience1 from 'static/images/intro-experience_1.png';
import introExperience2 from 'static/images/intro-experience_2.png';

/**
 * The Intro
 *
 * Ask the user if they are over 13,
 * then show some intro animations
 */
const Intro = (props) => {
  // Redirect if user is too young
  CookieRedirect();
  // History state and cookies
  const history = useHistory();
  // eslint-disable-next-line
  const [cookie, setCookie] = useCookies(['tooYoung', 'loggedIn', 'hasSeenIntro']);
  // State
  const [isOverThirteen, setIsOverThirteen] = useState(false);
  const [showIphoneHint, setShowIphoneHint] = useState(false);
  const [isChromeIOS, setIsChromeIOS] = useState(false);
  const [cameraError, setCameraError] = useState(false);
  const [logoShown, setLogoShown] = useState(false);
  // Variables
  const numSlides = 8;
  const slideDuration = 5000;


  /**
   * Start the experience
   */
  const start = () => {
    history.push('/main');
  };

  /**
   * Run helper screen for iphones,
   * to show how to close browser bar
   */
  const runIphoneHelper = () => {
    setCookie('tooYoung', false, { path: '/' });
    setCookie('loggedIn', true, { path: '/' });
    setCookie('hasSeenIntro', true, { path: '/' });
    const enableStream = async () => {
      try {
        let ua = navigator.userAgent.toLowerCase();
        let isIOS = /iPad|iPhone|iPod/.test(navigator.platform)
          || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        let isSafari = ua.indexOf('safari') !== -1 && !navigator.userAgent.match('CriOS');
        if (isIOS && !isSafari) {
          setIsChromeIOS(true);
        }
        if (isIOS && isSafari) {
          await navigator.mediaDevices.getUserMedia({audio: false, video: true});
          setShowIphoneHint(true);
        } else {
          runIntroAnim();
        }
      } catch(err) {
        setCameraError(true);
        console.warn(err);
        alert(err)
      }
    }
    enableStream();
  };

  /**
   * Start the intro animation,
   * called when the logo is loaded
   */
  const startIntro = () => {
    setTimeout(() => {
      setLogoShown(true);
    }, 1 * slideDuration);
    setTimeout(() => {
      start();
    }, numSlides * slideDuration + 1000);
  };

  /**
   * Call to run intro animation
   */
  const runIntroAnim = () => {
    setShowIphoneHint(false);
    setIsOverThirteen(true);
  };

  /**
   * Startup
   */
  useEffect(() => {
    runIphoneHelper();
    // eslint-disable-next-line
  }, []);

  return (
    <article className={classnames('Intro', {
      isChromeIOS: isChromeIOS
    })}>
      {!cameraError ? (
        <>
          <Logo className='Intro__logo' />
          {showIphoneHint && (
            <section className='Intro__iphone-hint'>
              <h3 className='Intro__iphone-hint-heading'>For the Best Experience</h3>
              <div className='Intro__iphone-hint-description'>
                <div className='Intro__iphone-hint-description__wrapper'>
                  <p className='Intro__iphone-hint-text'>Tap this [aA] in the search bar above</p>
                  <figure className='Intro__iphone-hint-figure'>
                    <img className='Intro__iphone-hint-image experience_one' alt='' src={introExperience1} />
                  </figure>
                </div>
                <div className='Intro__iphone-hint-description__wrapper'>
                  <p className='Intro__iphone-hint-text'>Then this</p>
                  <figure className='Intro__iphone-hint-figure'>
                    <img className='Intro__iphone-hint-image experience_two' alt='' src={introExperience2} />
                  </figure>
                </div>
              </div>
              <div className='Intro__iphone-hint-buttons'>
                <button className='button Intro__button Intro__iphone-hint-button' onClick={runIntroAnim}>Did It</button>
                <button className='Intro__iphone-hint-button' onClick={runIntroAnim}>No Thanks</button>
              </div>
            </section>
          )}
          {isOverThirteen && (
            <section className='Intro__animation'>
              {isChromeIOS ? (
                <figure className='Intro__video'><img src={introBgPoster} alt='Intro Video Poster' /></figure>
              ) : (
                <video className='Intro__video' playsInline autoPlay muted loop poster={introBgPoster}>
                  <source src={introBgVideo} type="video/mp4" />
                </video>
              )}
              <div className='Intro__animation-slide'>
                <div className='Intro__animation-slide--one'>
                  <figure className='Intro__slide Intro__slide__logo'>
                    <img src={logoLockup} alt='Reeses Puffs' onLoad={() => {
                      startIntro();
                    }} />
                  </figure>
                </div>
              </div>
              <div className='Intro__animation-slide'>
                <div className='Intro__animation-slide--two'>
                  <figure className='Intro__slide'>
                    <img src={intro1} alt='Hint: Place PUFFS on the squares in your cereal box' />
                  </figure>
                </div>
              </div>
              <div className='Intro__animation-slide'>
                <div className='Intro__animation-slide--three'>
                  <figure className='Intro__slide'>
                    <img src={intro2} alt='Hint: Point your phone at the cereal box to begin tracking' />
                  </figure>
                </div>
              </div>
              <div className='Intro__animation-slide'>
                <div className='Intro__animation-slide--four'>
                  <figure className='Intro__slide'>
                    <img src={intro3} alt='Hint: Hit play and listen to your beats' />
                  </figure>
                </div>
              </div>
              <div className='Intro__animation-slide'>
                <div className='Intro__animation-slide--five'>
                  <figure className='Intro__slide'>
                    <img src={intro4} alt='Hint: Lock pattern to keep the beat going' />
                  </figure>
                </div>
              </div>
              <div className='Intro__animation-slide'>
                <div className='Intro__animation-slide--six'>
                  <figure className='Intro__slide'>
                    <img src={intro5} alt='Hint: Try to have even lighting and avoid shadows' />
                  </figure>
                </div>
              </div>
              <div className='Intro__animation-slide'>
                <div className='Intro__animation-slide--seven'>
                  <figure className='Intro__slide'>
                    <img src={intro6} alt='Hint: Tap the record button to save your bops' />
                  </figure>
                </div>
              </div>
              <div className='Intro__animation-slide'>
                <div className='Intro__animation-slide--eight'>
                  <figure className='Intro__slide'>
                    <img src={intro7} alt='Hint: Make sure all four corners are on the screen' />
                  </figure>
                </div>
              </div>
              <figure className='Animation-wiggle Intro__animation-wiggle'>
                <div className='Animation-wiggle__icon'></div>
              </figure>
              <button
                className={classnames('button Intro__skip-button', {
                  show: logoShown
                })}
                onClick={() => {
                  start();
                }}
              ><span className='inner'>Skip Hints</span><Arrow /></button>
            </section>
          )}
        </>
      ) : (
        <div className='GenericAlert'>
          <Logo className='Intro__logo' />
          <h1 className='GenericAlert__title'>Sorry</h1>
          <section className='GenericAlert__description'>
            <p>We're having trouble accessing the camera on this device. You can try refreshing, or use a different device.</p>
          </section>
        </div>
      )}
    </article>
  )
};

export default Intro;
